import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { language } from './locales'
import App from './App';
import './assets/style/index.scss';

const container: any = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
    <ConfigProvider locale={language?.antd}>
        <App />
    </ConfigProvider>
);
